import { AddComponentOptions } from "../types";

export const defaultSearchComponentConfig: Partial<AddComponentOptions> = 
{
    container: ".search_form",
    name: "search-bar",
    placeholderText: "Search...",
};